import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./view.css";
import {
  admin_challenge_opportunity_update,
  challenges_approve_status,
  challenges_revert_status,
  get_challenge_opportunity_list,
} from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
export default function View(props) {
  const [data, setData] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const selectedParam = useParams();
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const getDetails = async (id) => {
    if (!id) return;
    try {
      setIsActive(true);
      const res = await get_challenge_opportunity_list();
      const found = Array.isArray(res)
        ? res.find((x) => String(x.id) === String(id))
        : null;
      const mapped = found
        ? {
          ...found,
          opportunity:
            found?.market_analysis_opportunity?.opportunity ??
            found?.market_analysis_opportunity_name ??
            found?.opportunity ??
            "",
          image: found?.image
            ? (found.image.startsWith("http")
              ? found.image
              : assetBaseUrl
                ? `${assetBaseUrl}/${String(found.image).replace(/^\//, "")}`
                : found.image)
            : "",
          brochure: found?.brochure
            ? (found.brochure.startsWith("http")
              ? found.brochure
              : assetBaseUrl
                ? `${assetBaseUrl}/${String(found.brochure).replace(/^\//, "")}`
                : found.brochure)
            : "",
        }
        : {};
      setData(mapped);
    } catch (error) {
      setData({});
      setSnackMessage(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch challenge opportunity details"
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    getDetails(selectedParam.id);
  }, [selectedParam]);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/challenges");
    }
  };
  const handleApproveStatus = () => {
    setIsActive(true);
    challenges_approve_status(selectedParam.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        getDetails(selectedParam.id);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
          error?.message ||
          "Failed to approve"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const handleRevertStatus = () => {
    setIsActive(true);
    challenges_revert_status(selectedParam.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        getDetails(selectedParam.id);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
          error?.message ||
          "Failed to reject"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const handleSubmit = () => {
    setIsActive(true);
    admin_challenge_opportunity_update(selectedParam.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        getDetails(selectedParam.id);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
          error?.message ||
          "Failed to submit for acceptance"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0 pt-2">
            <b>Challenge Opportunity Details</b>
          </h6>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              props.history.push("/challenges");
            }}
          >
            Back
          </button>
        </div>
        <hr />
        <div className="data">
          {data?.opportunity && (
            <div className="row">
              <div className="col-3">Opportunity</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.opportunity}</div>
            </div>
          )}
          {data?.title && (
            <div className="row">
              <div className="col-3">Title</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.title}</div>
            </div>
          )}
          {data?.description && (
            <div className="row">
              <div className="col-3">Description</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.description}</div>
            </div>
          )}
          {data?.due_date && (
            <div className="row">
              <div className="col-3">Due Date</div>
              <div className="col-1">:</div>
              <div className="col-7 mou-bw">{data.due_date}</div>
            </div>
          )}
          {data?.site_url && (
            <div className="row">
              <div className="col-3">Site URL</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <a href={data.site_url} target="_blank" rel="noreferrer">
                  {data.site_url}
                </a>
              </div>
            </div>
          )}
          {data?.brochure && (
            <div className="row">
              <div className="col-3">Reference Document</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <a href={data.brochure} target="_blank" rel="noreferrer">
                  {String(data.brochure).split("/").pop()}
                </a>
              </div>
            </div>
          )}
          {data?.image && (
            <div className="row">
              <div className="col-3">Image</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <img width={200} src={data.image} alt="" />
              </div>
            </div>
          )}
          {adminType === 2 &&
            data &&
            (String(data?.status).toLowerCase() === "pending" ||
              String(data?.status) === "0") && (
              <div className="d-flex justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-approve btn-success mr-2"
                  onClick={handleApproveStatus}
                >
                  Approve
                </button>
                <br />
                <button
                  type="button"
                  className="btn btn-reject btn-danger"
                  onClick={handleRevertStatus}
                >
                  Reject
                </button>
              </div>
            )}
          {/* {adminType === 1 && data && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={handleSubmit}
              >
                Submit for Acceptance
              </button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}
